import { useContext } from 'react';
import { BulkEnrichmentContext } from './context';
import { isContact } from '../../utils';
import { useEnrichmentPolicy } from '../../EnrichmentPolicy/useEnrichmentPolicy';
export function useBulkEnrichment() {
  const enrichmentPolicy = useEnrichmentPolicy();
  const machine = useContext(BulkEnrichmentContext);
  if (!machine) {
    throw new Error('useBulkEnrichment must be used within BulkEnrichmentProvider');
  }
  const {
    state,
    send
  } = machine;
  const enrichmentType = state.context.enrichmentType;
  const hasAccess = enrichmentPolicy.accessManualEnrichment(enrichmentType);
  const isLocked = !enrichmentPolicy.accessEnrichment();
  return {
    count: state.context.count,
    enrichAssociations: state.context.enrichAssociations,
    hasAccess,
    hasAccessBilling: enrichmentPolicy.accessBilling(),
    hasAccessEnrichAssociationsLists: enrichmentPolicy.accessEnrichAssociationsLists(),
    isContactEnrichment: isContact(enrichmentType),
    isLoading: state.hasTag('loading'),
    isLocked,
    onEnrich: () => send('ENRICH'),
    onToggleEnrichAssociations: () => send('TOGGLE_ENRICH_ASSOCIATED_RECORDS'),
    noAccess: !hasAccess,
    shouldOverwrite: state.context.shouldOverwrite,
    setShouldOverwrite: shouldOverwrite => send({
      type: 'SET_OVERWRITE',
      data: {
        shouldOverwrite
      }
    })
  };
}